





















import { AiCacheSearchResultItem } from "@/types/ai/aiSearch";
import { defineComponent, onBeforeMount, ref, getCurrentInstance, watch, computed } from "@vue/composition-api";
import AiResults from "../ai-results/AiResults.vue";
import AiFeedbackNotFound from "../ai-results/AiFeedbackNotFound.vue";
import storeHelper from "@/store/store-helper";
import { ContentItem } from "@infoland/iprova-api";
import Utils from "@/utils";

export default defineComponent({
    name: "BrowseResultsContainer",
    props: {
        portalId: { type: Number, required: true },
        collectionId: { type: Number, required: false, default: () => null }
    },
    components: {
        AiResults,
        AiFeedbackNotFound
    },
    setup(props, { emit }) {
        const browseResults = ref<AiCacheSearchResultItem[] | undefined>(undefined);
        const showMoreAmount = storeHelper.aiBrowseStore.getClientPageSize();
        const itemsToShow = computed(() => storeHelper.aiBrowseStore.getItemsToShow(props.portalId, props.collectionId) ?? showMoreAmount);

        /**
         * Load the content items before the component is mounted
         */
        onBeforeMount(() => {
            loadContentItemsAsync();
        });

        /**
         * if any props change, get the search results again
         */
        watch(
            () => props,
            () => loadContentItemsAsync(),
            { deep: true }
        );

        /**
         * Load the content items from the store
         */
        const loadContentItemsAsync = async () => {
            emit("content-items-loaded", false);
            browseResults.value = null;
            browseResults.value = await storeHelper.aiBrowseStore.loadResultsAsync(props.portalId, props.collectionId);
            storeHelper.aiBrowseStore.setItemsToShow(props.portalId, props.collectionId, itemsToShow.value);
            emit("content-items-loaded", true);
        };

        /**
         * Handle the item click event
         * @param item - the item that was clicked
         */
        const router = getCurrentInstance().proxy.$router;
        const handleItemClick = (item: AiCacheSearchResultItem) => {
            const contentItem = {
                content_item_id: item.content_item_id,
                source_item_id: item.source_item_id,
                content_type: {
                    content_type_id: item.content_type_id
                },
                sub_type_field: {
                    value_id: item.content_sub_type_id
                }
            } as ContentItem;
            Utils.openContentItem(contentItem, router, props.portalId);
        };

        /**
         * Handle the show more event
         * @param currentItemsShown - the current amount of items
         * @param showMoreAmount - the amount of items to show more
         */
        const handleShowMoreAsync = async (currentItemsShown: number, showMoreAmount: number) => {
            storeHelper.aiBrowseStore.setItemsToShow(props.portalId, props.collectionId, currentItemsShown);

            const shouldBuffer = browseResults.value.length - currentItemsShown < showMoreAmount;
            if (shouldBuffer) {
                const newResults = await storeHelper.aiBrowseStore.loadMoreAsync(props.portalId, props.collectionId, currentItemsShown);
                browseResults.value = [...browseResults.value, ...newResults];
            }
        };

        const areAllItemsLoaded = () => {
            return storeHelper.aiBrowseStore.areAllItemsLoaded(props.portalId, props.collectionId);
        };

        return {
            handleItemClick,
            handleShowMoreAsync,
            areAllItemsLoaded,
            itemsToShow,
            browseResults,
            showMoreAmount
        };
    }
});
